import { ITirPmMultiselectOption } from "tir-components";

/**
 * * Модель опции выбора тега в мультиселекте
 */
export class TagMultiselectOptionModel implements ITirPmMultiselectOption {
  /**ID тега */
  Id!: number;
  /**Название тега */
  Name!: string;
  /**Цвет тега */
  Color!: string;
  /**Описание */
  Description?: string;

  search = (searchString: string) => {
    return (this.Name ?? "").toLocaleLowerCase().includes((searchString ?? "").toLocaleLowerCase());
  };

  constructor(obj?: Partial<TagMultiselectOptionModel>) {
    Object.assign(this, obj);
  }
}
